/**
 * UI-Gating-Konstanten (docs/PERMISSIONS.md) — nur zum Ein-/Ausblenden von
 * Bearbeiten-/Löschen-Buttons im Frontend. Durchgesetzt wird ausschließlich
 * serverseitig über require_permission_set(...) in backend/app/core/security.py;
 * diese Listen sind bewusst 1:1 aus der PERMISSIONS.md-Rollentabelle abgeleitet
 * und müssen bei Änderungen dort synchron gehalten werden.
 */

export const ROLE_ADMIN_PLATTFORM = "admin"
export const ROLE_ADMIN = "app:technik:admin"
export const ROLE_LEITUNG = "app:technik:leitung"
export const ROLE_PFLEGE = "app:technik:pflege"
export const ROLE_TECHNIK = "app:technik:technik"
export const ROLE_LESEN = "app:technik:lesen"

/** technik_schreiben: Stammdaten anlegen/ändern (Anlagen/Objekte/Komponenten/...) */
export const ROLES_TECHNIK_SCHREIBEN = [ROLE_ADMIN_PLATTFORM, ROLE_ADMIN, ROLE_LEITUNG, ROLE_PFLEGE] as const

/** technik_loeschen: dieselben Ressourcen wie technik_schreiben, nur Leitung+admin */
export const ROLES_TECHNIK_LOESCHEN = [ROLE_ADMIN_PLATTFORM, ROLE_ADMIN, ROLE_LEITUNG] as const

/** tickets_schreiben: Tickets anlegen/bearbeiten */
export const ROLES_TICKETS_SCHREIBEN = [
  ROLE_ADMIN_PLATTFORM,
  ROLE_ADMIN,
  ROLE_LEITUNG,
  ROLE_PFLEGE,
  ROLE_TECHNIK,
] as const

/** ereignis_melden: Ereignis melden */
export const ROLES_EREIGNIS_MELDEN = [
  ROLE_ADMIN_PLATTFORM,
  ROLE_ADMIN,
  ROLE_LEITUNG,
  ROLE_PFLEGE,
  ROLE_TECHNIK,
] as const

/** zeit_buchen: Zeitbuchungen anlegen */
export const ROLES_ZEIT_BUCHEN = [
  ROLE_ADMIN_PLATTFORM,
  ROLE_ADMIN,
  ROLE_LEITUNG,
  ROLE_PFLEGE,
  ROLE_TECHNIK,
] as const
